import { render, staticRenderFns } from "./MQSeriesConfigurationDetails.vue?vue&type=template&id=f9682d18&"
import script from "./MQSeriesConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./MQSeriesConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9682d18')) {
      api.createRecord('f9682d18', component.options)
    } else {
      api.reload('f9682d18', component.options)
    }
    module.hot.accept("./MQSeriesConfigurationDetails.vue?vue&type=template&id=f9682d18&", function () {
      api.rerender('f9682d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/MQSeriesConfigurationDetails.vue"
export default component.exports